import { Box, HStack, Text, ModalCloseButton, useDisclosure } from '@chakra-ui/react';

import StyledModal from '@components/general/modals/styled-modal.component';
import CardSearchStructuredModalContent from './card-search-structured-modal-content.component';
const CardSearchModalWrapped = ({ submitFn }) => {
  return (
    <Box
      h='600px'
      w='full'
      display='flex'
      flexDirection='column'
    >
      <CardSearchStructuredModalContent submitFn={submitFn} />
    </Box>
  );
};

export default function CardSearchModal({ disclosure, submitFn }) {
  const defaultDisclosure = useDisclosure();
  const modalDisclosure = disclosure || defaultDisclosure;

  const handleClose = () => {
    modalDisclosure.onClose();
  };

  return (
    <StyledModal
      title='Search Meeting Summaries'
      disclosure={modalDisclosure}
      modalProps={{
        scrollBehavior: 'inside',
        blockScrollOnMount: false,
        size: '6xl'
      }}
      modalContentProps={{
        maxH: 'calc(100vh - 48px)',
        w: { base: '90vw', md: '90vw', lg: '1200px' },
        h: { base: '85vh', md: '85vh' }
      }}
      modalBodyProps={{
        p: 0,
        overflow: 'hidden'
      }}
      customHeader={
        <HStack
          color='brandPrimary.onPrimary'
          bgColor='brandPrimary.primary'
          py={4}
          px={{ base: 6, sm: 4 }}
        >
          <Text fontWeight={500}>Search Summaries</Text>
          <ModalCloseButton />
        </HStack>
      }
    >
      <CardSearchModalWrapped
        submitFn={(cardIds) => {
          submitFn(cardIds);
          handleClose();
        }}
      />
    </StyledModal>
  );
}
